import { useRecoilValueLoadable } from 'recoil'
import { selectors } from 'store'

const useContent = () => {
  const { contents, state } = useRecoilValueLoadable(selectors.contentSelector)
  return { content: contents, state }
}

export { useContent }
